import * as React from 'react';
import { useDispatch } from 'react-redux';
import { logging } from 'gandi.redux-logger';
import { isFetchError } from '../redux/actions';
function useLogger(namespace) {
  const dispatch = useDispatch();
  return React.useMemo(() => logging(dispatch, namespace), [dispatch, namespace]);
}
export function useFetchErrorHandler(namespace) {
  const logger = useLogger(namespace);
  return React.useCallback((err, message) => {
    const response = isFetchError(err) ? err.response : undefined;
    if (!response || typeof response.status !== 'number') {
      logger.fatal({
        err
      }, message);
      return;
    }
    switch (true) {
      case response.status < 400:
        logger.warn({
          err
        }, message);
        break;
      case response.status === 401:
        logger.info({
          err
        }, message);
        break;
      case response.status === 403:
        logger.warn({
          err
        }, message);
        break;
      case response.status >= 400 && response.status < 500:
        logger.error({
          err
        }, message);
        break;
      case response.status >= 500:
        logger.error({
          err
        }, message);
        break;
      default:
        logger.fatal({
          err
        }, message);
    }
  }, [logger]);
}